import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';
import Tooltip from 'src/components/ui-kit/Tooltip';
import { useStore } from 'src/hooks/useStore';
import { useLocation } from 'react-router-dom';
import useService from 'src/hooks/useService';
import { IReqPatentRightsPage } from 'src/types/api/patentRightsApiTypes';
import { IReqTmarkRightsPage } from 'src/types/api/trademarkRightsApiTypes';
import QueryString from 'qs';
import CsvDownload from 'src/components/contents/search/result/CsvDownload';

const Wrapper = styled.div<{ bgImg: string }>`
  display: flex;
  border-radius: 20px;
  width: 80%;
  height: 85px;
  margin-top: 20px;

  background-image: url(${(props) => props.bgImg});
  background-size: 100% 100%;

  @media (max-width: ${mobilePoint}) {
    width: 100%;
    height: 200px;
    top: 0;
    margin-top: 0;
    border-radius: 0;
    background-size: 100% 200px;
  }
`;
const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20%;
  width: 80%;
  position: relative;

  @media (max-width: ${mobilePoint}) {
    width: 100%;
    display: block;
    padding: 3em;
    margin-left: 0;
    overflow: hidden;
  }
`;
const Title = styled.div`
  font-family: NotoSansTC-Bold;
  font-size: 28px;
  color: ${colors.white};
  cursor: default;
  white-space: nowrap;
  @media (max-width: ${mobilePoint}) {
    margin-bottom: 1em;
  }
`;
const Content = styled.div`
  color: ${colors.white};
  width: 40%;
  margin-top: 10px;
  margin-left: 8px;
  cursor: default;

  @media (max-width: ${mobilePoint}) {
    font-size: 24px;
    margin: 0;
  }
`;
const ToolText = styled.div`
  font-size: 18px;
  display: flex;
  align-items: center;
`;
const SubtitleText = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
const Item = styled.div`
  overflow: hidden;
  div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  br {
    display: none;
  }
`;
const Icon = styled.div`
  margin: 5px;
`;
const CardImg = styled.img`
  height: 128px;
  position: absolute;
  top: -40px;
  left: -25%;
  @media (max-width: ${mobilePoint}) {
    height: 128px;
    top: 4em;
    left: 70%;
  }
`;

interface IProps {
  title: string;
  buttonText?: string;
  buttonOnClick?: () => void;
  bgImg: string;
  image: string;
  bgColor: string;
  tip?: React.ReactNode;
  subtitle?: string;
  reqParams?: IReqPatentRightsPage | IReqTmarkRightsPage;
  totalNum?: number;
}

const DetailBanner: React.FC<IProps> = ({
  title,
  bgImg,
  image,
  bgColor,
  tip,
  subtitle,
  reqParams,
  totalNum,
}) => {
  const isMobile = useStore((state) => state.isMobile);
  const { pathname } = useLocation();
  const path = useService();

  const isSearchResult = pathname === path + '/result';
  const mobileTipTitle = '查詢條件';

  // CSV檔案下載網址前綴
  const getApiPath = () => {
    switch (path) {
      case process.env.PUBLIC_URL + '/patentRights':
        return 'PatentRights';
      case process.env.PUBLIC_URL + '/trademarkRights':
        return 'TmarkRights';
    }
  };
  const apiPath = getApiPath();
  const csvDownloadPath =
    apiPath &&
    process.env.REACT_APP_API_URL +
      apiPath +
      '/download/csv?' +
      QueryString.stringify(reqParams, { allowDots: true });

  return (
    <Wrapper bgImg={bgImg}>
      <InnerWrapper>
        <Title><h1>{title}</h1></Title>
        <Content>
          {tip && (
            <Tooltip overlay={tip} bgColor={bgColor}>
              <ToolText>
                <Icon>
                  <FaExclamationCircle />
                </Icon>
                <Item>{isMobile ? mobileTipTitle : tip}</Item>
              </ToolText>
            </Tooltip>
          )}
          {subtitle && <SubtitleText>{subtitle}</SubtitleText>}
        </Content>
        <CardImg src={image} alt="" ></CardImg>
        {isSearchResult && !isMobile && (
          <CsvDownload csvDownloadPath={csvDownloadPath} totalNum={!!totalNum ? totalNum : 0} />
        )}
      </InnerWrapper>
    </Wrapper>
  );
};

export default DetailBanner;
